// @ts-expect-error TS7006 Issue #4120
export const takeFirst = (func) => {
    // @ts-expect-error TS7034 Issue #4120
    let runningFunc, undefinedFunc;

    // @ts-expect-error TS7019 Issue #4120
    return (...args) => {
        // @ts-expect-error TS7005 Issue #4120
        if (!runningFunc) {
            runningFunc = func(...args).finally(() => {
                runningFunc = undefinedFunc;
            });
        }

        return runningFunc;
    };
};
